import { realmPlugin, addImportVisitor$, isMdastHTMLNode } from "@mdxeditor/editor";
import { createSafeHtmlVisitor } from "./safeHtmlVisitor";

// Strips script-capable tags and attributes from raw HTML in markdown before
// MDXEditor turns it into DOM nodes. See safeHtmlVisitor.js.
export const safeHtmlPlugin = realmPlugin({
  init(realm) {
    realm.pubIn({
      [addImportVisitor$]: createSafeHtmlVisitor(isMdastHTMLNode),
    });
  },
});
